import { Accordion } from '@toggle/design-system';
import React from 'react';
import { useTranslation } from 'react-i18next';

import sharedStyles from '~/components/citations-section/CitationsSection.module.scss';
import * as Shared from '~/components/citations-section/CitationsSection.styles';

import { DocumentsRow } from './documents-row/DocumentsRow';

export interface DocumentsSectionProps {
  title: string;
  count: number;
  items: { id: string; name: string }[];
}

export const DocumentsSection = ({
  title,
  count,
  items,
}: DocumentsSectionProps) => {
  const { t } = useTranslation(['earnings']);

  const accordionItems = [
    {
      title: (
        <Shared.TitleContainer>
          <Shared.TitleLabel>{title}</Shared.TitleLabel>
          <Shared.CountLabel>
            {t('earnings:earningsInsight.drawer.count', { count })}
          </Shared.CountLabel>
        </Shared.TitleContainer>
      ),
      content: items.map(item => (
        <Shared.ItemContainer key={item.id}>
          <DocumentsRow id={item.id} name={item.name} />
        </Shared.ItemContainer>
      )),
      expandedByDefault: true,
    },
  ];
  return (
    <Accordion
      className={sharedStyles.styledAccordion}
      items={accordionItems}
    />
  );
};
